import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import Utils from '../../../utils';

@Component({
  selector: 'app-navigation-arrow',
  templateUrl: './navigation-arrow.component.html'
})
export class NavigationArrowComponent implements OnChanges {

  @Input() isAllNode = false;
  @Input() taxonomyData; // main taxonomy tree data
  @Input() showNavigation = false; // holds boolean value for showing up navigation arrow
  @Input() firstNode: any; // first node in tree
  @Input() lastNode: any; // last node in tree
  @Input() selectedNode: any; // current selected node on tree
  @Output() nextClickEvent = new EventEmitter();
  @Output() previousClickEvent = new EventEmitter();
  tempNode: any;
  parentNode: any;
  tempTaxonomyData: any = [];

  // view location from which navigation arrow is called
  @Input() viewLocation: any;

  // utils static function variables
  taxonyDetailEnum = Utils.TAXONOMY_DETAILS_VIEW;

  // flatten the tree array structure
  flattenedArray: any;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.taxonomyData && changes.taxonomyData.currentValue) {
      this.taxonomyData = changes.taxonomyData.currentValue;
      if (this.taxonomyData && this.viewLocation !== this.taxonyDetailEnum) {
        if (this.isAllNode === false && this.taxonomyData[0] && this.taxonomyData[0].children[0]) {
          this.tempTaxonomyData = this.taxonomyData;
          if (this.taxonomyData[0].children[0]['isOrphanLabel']) { // skipping orphan node lable if any
            if (!this.firstNode) {
              this.firstNode = this.taxonomyData[0].children[0].children[0];
            }
          } else {
            if (!this.firstNode) {
              this.firstNode = this.taxonomyData[0].children[0];
            }
          }
        } else if (this.isAllNode === true) {
          this.tempTaxonomyData = this.taxonomyData.children;
          this.firstNode = this.taxonomyData.children[0];
        }
        this.lastNode = this.findLastNode(this.taxonomyData);
      }
      // TODO : this is required for the new treeView UF-24996 navigation
      // of nodes and need to remove and make it dynamic
      if (this.viewLocation === this.taxonyDetailEnum){
          this.flattenedArray = [];
          this.flattenedArray = this.flattenedTaxonomyArray([this.taxonomyData['0']]);
          this.firstNode = this.flattenedArray[0];
          this.lastNode =  this.flattenedArray[this.flattenedArray.length - 1];
      }
    }
  }


  /**
   * On next button click
   */
  onTreeNavigateNextClick() {
    this.selectedNode['expand'] = true;
    this.selectedNode = this.loadNextNode(this.selectedNode);
    if (this.selectedNode.isOrphanLabel) { // Don't navigate to orphan node label
      this.onTreeNavigateNextClick();
    }
    this.nextClickEvent.emit({'node': this.selectedNode});
  }

  /**
   * On previous button click
   */
  onTreeNavigatePreviousClick() {
    this.loadPreviousNode(this.selectedNode);
    if (this.tempNode.isOrphanLabel) { // Don't navigate to orphan node label
      this.selectedNode = this.tempNode;
      this.onTreeNavigatePreviousClick();
    }
    this.selectedNode = this.tempNode;
    this.previousClickEvent.emit({'node': this.selectedNode});
  }

  /**
   * To load next node of current node
   * @param selectedNode (current node)
   */
  loadNextNode(selectedNode) {
    if (selectedNode) {
      if (selectedNode.children && selectedNode.children.length > 0) { // If node has children
        return selectedNode.children[0];
      } else { // If no children
        this.getAvailableNode(selectedNode);
        return this.tempNode;
      }
    } else {
      return null;
    }
  }

  /**
   * To get next available node
   * @param currNode
   */
  getAvailableNode(currNode) {
    let parent, childList = [],
      position = 0;
    if (currNode.parent_id) {
      this.getParentNodeObject(currNode.parent_id);
      parent = this.parentNode;
      childList = parent.children;
      if (childList.length > 0) {
        position = this.findIndexInList(currNode, childList);
        if (position < childList.length - 1) { // If node is not in last position
          this.tempNode = childList[position + 1];
        } else { // If last position
          this.getAvailableNode(parent);
        }
      }
    } else {
      if (this.tempTaxonomyData && this.tempTaxonomyData.length > 1) {
        position = this.findIndexInList(currNode, this.tempTaxonomyData);
        this.tempNode = this.tempTaxonomyData[position + 1].children[0];
      } else {
        this.tempNode = this.firstNode;
      }
    }
  }

  /**
   * To load previous node of current node
   * @param selectedNode (current node)
   */
  loadPreviousNode(selectedNode) {
    let parent, childList = [],
      position = 0;
    if (selectedNode && selectedNode.parent_id) {
      this.getParentNodeObject(selectedNode.parent_id);
      parent = this.parentNode;
      childList = parent.children;
      if (childList.length > 0) {
        position = this.findIndexInList(selectedNode, childList);
        if (position > 0) { // If node is not in first position
          this.tempNode = childList[position - 1];
          if (this.tempNode.children.length > 0) {
            this.tempNode = this.findLastNode(this.tempNode.children[this.tempNode.children.length - 1]);
          }
        } else { // in first position
          if (parent && parent.parent_id) {
            this.tempNode = parent;
          } else {
            this.loadPreviousNode(parent);
          }
        }
      }
    } else {
      const tempTaxonomyData = this.taxonomyData.children ? this.taxonomyData.children : this.taxonomyData;
      if (tempTaxonomyData && tempTaxonomyData.length > 1) {
        position = this.findIndexInList(selectedNode, tempTaxonomyData);
        const childPosition = tempTaxonomyData[position - 1].children.length - 1;
        this.tempNode = this.findLastNode(tempTaxonomyData[position - 1].children[childPosition]);
      } else {
        this.tempNode = tempTaxonomyData.length === 1 ? this.firstNode : this.lastNode;
      }
    }
  }

  /**
   * To fond position of element in a list
   * @param element
   * @param list
   */
  findIndexInList(element, list) {
    return list.findIndex(obj => ((obj.id === element.item_id) || (obj.id === element.id)));
  }

  /**
   * To find last node of tree
   * @param node
   */
  findLastNode(node: any) {
    if (node.children && node.children.length > 0) {
      return this.findLastNode(node.children[node.children.length - 1]);
    } else if (node && node.length > 0) {
      return this.findLastNode(node[node.length - 1]);
    } else {
      return JSON.parse(JSON.stringify(node));
    }
  }

  getParentNodeObject(parentId) {
    const taxoData = this.taxonomyData.children ? this.taxonomyData.children : this.taxonomyData;
    taxoData.forEach(element => {
      this.getParent(element, parentId);
    });
  }

  getParent(node, parentId) {
    if (node.id === parentId) {
      this.parentNode = node;
    } else {
      if (node.children.length > 0) {
        node.children.forEach(element => {
          this.getParent(element, parentId);
        });
      }
    }
  }

    // On tree navigation previous event
    onTreeNavigatePreviousEvent() {
      this.selectedNode = this.getPreviousNode(this.selectedNode);
      this.selectedNode.expand = true;
      this.previousClickEvent.emit(this.selectedNode);
    }

    // On tree navigation next event
    onTreeNavigateNextEvent() {
      if ((this.selectedNode.has_children
            && this.selectedNode.children
            && this.selectedNode.children.length > 0)
            || (this.selectedNode.has_children === 'false')
      ) {
        this.selectedNode = this.getNextNode(this.selectedNode);
      }
      this.selectedNode.expand = true;
      this.nextClickEvent.emit(this.selectedNode);
    }

    /**
     * Flattened the recursive tree array
     *
     * @param data taxonomyData
     *
     * @returns the flattened array for the recursive structure
     */
    flattenedTaxonomyArray(data: any) {
      let result = [];
      data.forEach((a: any) => {
          result.push(a);
          if (Array.isArray(a.children)) {
              result = result.concat(this.flattenedTaxonomyArray(a.children));
          }
      });
      return result;
    }

    /**
     * Get Next node when the right arrow is clicked
     *
     * @param selectedNode current selected node for the next navigation
     *
     * @returns the next node
     */
    getNextNode(selectedNode) {
      const position = this.findElementIndexInList(selectedNode, this.flattenedArray);
      if (position < this.flattenedArray.length - 1) {
        return this.flattenedArray[position + 1];
      }
      return this.flattenedArray[0];
    }

    /**
     * For previous node navigation
     *
     * @param selectedNode current selected node for the previous navigation
     *
     * @returns returns the previous node
     */
    getPreviousNode(selectedNode) {
      const position = this.findElementIndexInList(selectedNode, this.flattenedArray);
      if (position > 0 ) {
        return this.flattenedArray[position - 1];
      }
      return this.flattenedArray[0];
    }

    /**
     * For finding element based on index
     *
     * @param element element to be search in the list
     * @param list list for searching an elements index
     *
     * @returns the position of the selected inde
     */
    findElementIndexInList(element, list) {
        return list.findIndex(obj => (obj.item_id === element.item_id));
    }
}
